<template>
  <div class="video-meeting-attachment">
    <div class="video-meeting-attachment__content">
      <Icon icon="mdi:video" class="video-meeting-attachment__icon" />
      <div class="video-meeting-attachment__info">
        <span class="video-meeting-attachment__label">Video Meeting</span>
        <span v-if="attachment.starts_at" class="video-meeting-attachment__time">
          {{ formatMeetingTime(attachment.starts_at) }}
        </span>
        <span v-if="attachment.time_range" class="video-meeting-attachment__duration">
          Duration: {{ formatDuration(attachment.time_range) }}
        </span>
      </div>
      <a
        v-if="attachment.url"
        :href="attachment.url"
        target="_blank"
        class="video-meeting-attachment__join"
        @click.stop
      >
        <Icon icon="mdi:video-plus" />
        <span>Join Meeting</span>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Attachment } from "@/dtos/Unipile.dto";
import { Icon } from "@iconify/vue";

interface Props {
  attachment: Attachment;
}

defineProps<Props>();

const formatDuration = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  }
  return `${minutes}:${secs.toString().padStart(2, "0")}`;
};

const formatMeetingTime = (timestamp: number): string => {
  const date = new Date(timestamp * 1000);
  return date.toLocaleString("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
};
</script>

<style scoped>
.video-meeting-attachment {
  display: flex;
  align-items: center;
  padding: 0.75rem;
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

.video-meeting-attachment__content {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 1;
}

.video-meeting-attachment__icon {
  font-size: 1.5rem;
  color: #6b7280;
  flex-shrink: 0;
}

.video-meeting-attachment__info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
}

.video-meeting-attachment__label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #111827;
}

.video-meeting-attachment__time {
  font-size: 0.75rem;
  color: #6b7280;
}

.video-meeting-attachment__duration {
  font-size: 0.75rem;
  color: #6b7280;
}

.video-meeting-attachment__join {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background: #0077b5;
  color: white;
  border-radius: 6px;
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 500;
  transition: background 0.2s;
  flex-shrink: 0;
}

.video-meeting-attachment__join:hover {
  background: #006399;
}
</style>
